import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import SignIn from './SignIn';
import OptionPlanner from './functions/OptionPlanner';

ReactDOM.render(<App />, document.getElementById('root'));